import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { useAppSelector } from "../../app/store/configureStore";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  textbox: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const CommunicationDevelopment: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const isHomeVisitor = user?.credentialTypeId === 4;
  const systemCodeId = isHomeVisitor ? 62 : 61;

  const defaultValues = {
    textbox: answersData.find((answer) => answer.systemCodeId === systemCodeId)
      ?.answer,
  };
  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderCommunicationCSIIdCompetence = () => {
    return (
      <>
        <li>
          What activities can be implemented to promote early literacy skills?
        </li>
        <li>
          What steps can be taken to enhance communication for dual language
          learners?
        </li>
        <li>
          What resources can be utilized to help children develop a wide range
          of abilities to communicate verbally and nonverbally?
        </li>
        <li>
          What resources and materials can be implemented to support children
          with language delays or difficulties?
        </li>
      </>
    );
  };

  return (
    <Grid container pb={3}>
      <Grid item xs={12} px={3} pt={3}>
        <Typography variant="body1" fontWeight="bold" paragraph>
          {user?.credentialTypeId !== 4
            ? "CS II-d - Communication & Language Development"
            : "CS II-d - Communication"}
        </Typography>
        <Typography variant="body1" paragraph>
          {user?.credentialTypeId !== 4
            ? "How can you support the communication and language development for all children, including those whose first language is not English? "
            : "Describe ways to support families so they can promote communication among family members, including all children and those who are dual language learners."}
        </Typography>
        <ReadMoreReadLess>
          <>{renderCommunicationCSIIdCompetence()}</>
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12} px={3} pt={3}>
        <TextField
          label={
            user?.credentialTypeId !== 4
              ? "Ways to promote communication and language development for all children include"
              : "Ways to promote communication among family members, including children and dual language learners, include"
          }
          multiline
          rows={2}
          fullWidth
          {...register("textbox")}
          name="textbox"
          value={
            answersData.find((answer) => answer.systemCodeId === systemCodeId)
              ?.answer || ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.textbox?.message}
          helperText={errors.textbox?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.textbox?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default CommunicationDevelopment;
